export const SB_URL = "https://vcxvhesjpxxgnnwbxpbs.supabase.co";
export const SB_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZjeHZoZXNqcHh4Z25ud2J4cGJzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODE1MTYzNzUsImV4cCI6MjA5NzA5MjM3NX0.c_Fg5VLTnKgYVA0qI5PjxYQXygpZOjZKRqTLHCpRdRo";

export const SBH = {
  apikey: SB_KEY,
  Authorization: `Bearer ${SB_KEY}`,
  "Content-Type": "application/json",
  Accept: "application/json",
};

export const sb = {
  async get(path: string): Promise<any[]> {
    try {
      const r = await fetch(`${SB_URL}/rest/v1/${path}`, { headers: SBH });
      if (!r.ok) {
        console.warn(`SB GET ${path} → ${r.status}`, await r.text());
        return [];
      }
      return r.json();
    } catch (e) {
      console.warn("SB GET:", e);
      return [];
    }
  },

  async insert(table: string, data: unknown) {
    try {
      const r = await fetch(`${SB_URL}/rest/v1/${table}`, {
        method: "POST",
        headers: {
          ...SBH,
          Prefer: "resolution=ignore-duplicates,return=minimal",
        },
        body: JSON.stringify(data),
      });
      if (!r.ok)
        console.warn(`SB INSERT ${table} → ${r.status}`, await r.text());
      return r.ok;
    } catch (e) {
      console.warn("SB INSERT:", e);
      return false;
    }
  },

  // Plain INSERT — no ON CONFLICT. `insert` uses resolution=ignore-duplicates,
  // which makes PostgREST emit ON CONFLICT and therefore REQUIRE SELECT on the
  // table. Append-only logs written by insert-only roles (e.g. anon on
  // pve_fights, which has INSERT but deliberately NOT SELECT) must use this.
  async insertEvent(table: string, data: unknown) {
    try {
      const r = await fetch(`${SB_URL}/rest/v1/${table}`, {
        method: "POST",
        headers: { ...SBH, Prefer: "return=minimal" },
        body: JSON.stringify(data),
      });
      if (!r.ok)
        console.warn(`SB INSERT_EVENT ${table} → ${r.status}`, await r.text());
      return r.ok;
    } catch (e) {
      console.warn("SB INSERT_EVENT:", e);
      return false;
    }
  },

  async upsert(table: string, data: unknown) {
    try {
      const r = await fetch(`${SB_URL}/rest/v1/${table}`, {
        method: "POST",
        headers: {
          ...SBH,
          Prefer: "resolution=merge-duplicates,return=minimal",
        },
        body: JSON.stringify(data),
      });
      if (!r.ok)
        console.warn(`SB UPSERT ${table} → ${r.status}`, await r.text());
      return r.ok;
    } catch (e) {
      console.warn("SB UPSERT:", e);
      return false;
    }
  },

  async delete(table: string, filter: string) {
    try {
      const r = await fetch(`${SB_URL}/rest/v1/${table}?${filter}`, {
        method: "DELETE",
        headers: { ...SBH, Prefer: "return=minimal" },
      });
      if (!r.ok) console.warn(`SB DELETE ${table} → ${r.status}`, await r.text());
      return r.ok;
    } catch (e) {
      console.warn("SB DELETE:", e);
      return false;
    }
  },

  async patch(table: string, filter: string, data: unknown) {
    try {
      const r = await fetch(`${SB_URL}/rest/v1/${table}?${filter}`, {
        method: "PATCH",
        headers: { ...SBH, Prefer: "return=minimal" },
        body: JSON.stringify(data),
      });
      if (!r.ok)
        console.warn(`SB PATCH ${table} → ${r.status}`, await r.text());
      return r.ok;
    } catch (e) {
      console.warn("SB PATCH:", e);
      return false;
    }
  },

  async rpc(name: string, params: Record<string, unknown> = {}): Promise<any> {
    try {
      const r = await fetch(`${SB_URL}/rest/v1/rpc/${name}`, {
        method: "POST",
        headers: SBH,
        body: JSON.stringify(params),
      });
      if (!r.ok) {
        console.warn(`SB RPC ${name} → ${r.status}`, await r.text());
        return null;
      }
      return r.json();
    } catch (e) {
      console.warn("SB RPC:", e);
      return null;
    }
  },

  // RPC called with the USER's JWT (not the anon key) so SECURITY DEFINER functions
  // resolve auth.uid() to the real user. Returns the DB error message on failure so
  // the caller can map it to a user-facing string.
  async rpcAuthed(
    name: string,
    params: Record<string, unknown>,
    accessToken: string
  ): Promise<{ ok: boolean; data: any; error: string | null }> {
    try {
      const r = await fetch(`${SB_URL}/rest/v1/rpc/${name}`, {
        method: "POST",
        headers: {
          apikey: SB_KEY,
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(params),
      });
      const text = await r.text();
      if (!r.ok) {
        let msg = text;
        try { msg = JSON.parse(text)?.message ?? text; } catch {}
        console.warn(`SB RPC(authed) ${name} → ${r.status}`, text);
        return { ok: false, data: null, error: msg || `RPC ${name} failed (${r.status})` };
      }
      return { ok: true, data: text ? JSON.parse(text) : null, error: null };
    } catch (e) {
      console.warn("SB RPC(authed):", e);
      return { ok: false, data: null, error: String(e) };
    }
  },
};

const PNAME_KEY = "pronocup_v4_name";
const PCACHE_KEY = "pronocup_v4_player";
const BCACHE_KEY = "pronocup_v4_bets";
const RCACHE_KEY = "pronocup_v4_results";

export const loadName = (): string | null => {
  try {
    return localStorage.getItem(PNAME_KEY);
  } catch {
    return null;
  }
};

export const saveName = (n: string): void => {
  try {
    localStorage.setItem(PNAME_KEY, n);
  } catch {}
};

export const saveCache = (player: unknown, bets: unknown): void => {
  try {
    localStorage.setItem(PCACHE_KEY, JSON.stringify(player));
    localStorage.setItem(BCACHE_KEY, JSON.stringify(bets));
  } catch {}
};

export const loadCache = (): { player: any; bets: Record<string, any> } => {
  try {
    const p = localStorage.getItem(PCACHE_KEY);
    const b = localStorage.getItem(BCACHE_KEY);
    return { player: p ? JSON.parse(p) : null, bets: b ? JSON.parse(b) : {} };
  } catch {
    return { player: null, bets: {} };
  }
};

export const saveResultsCache = (results: Record<string, any>): void => {
  try {
    localStorage.setItem(RCACHE_KEY, JSON.stringify(results));
  } catch {}
};

export const loadResultsCache = (): Record<string, any> | null => {
  try {
    const r = localStorage.getItem(RCACHE_KEY);
    return r ? JSON.parse(r) : null;
  } catch {
    return null;
  }
};

const MATCHCACHE_KEY = "pronocup_v4_matches";
const DERIVED_CACHE_PREFIX = "pronocup_v4_derived_";

export const saveLastDerived = (
  playerName: string,
  d: { earned: number; won: number; total: number; winrate: number; wallet: number }
): void => {
  try {
    localStorage.setItem(DERIVED_CACHE_PREFIX + playerName, JSON.stringify(d));
  } catch {}
};

export const loadLastDerived = (
  playerName: string
): { earned: number; won: number; total: number; winrate: number; wallet: number } | null => {
  try {
    const raw = localStorage.getItem(DERIVED_CACHE_PREFIX + playerName);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const saveMatchesCache = (matches: any[]): void => {
  try {
    localStorage.setItem(MATCHCACHE_KEY, JSON.stringify(matches));
  } catch {}
};

export const loadMatchesCache = (): any[] | null => {
  try {
    const m = localStorage.getItem(MATCHCACHE_KEY);
    return m ? JSON.parse(m) : null;
  } catch {
    return null;
  }
};
